export default __webpack_public_path__ + "static/media/english-to-chinese-logo.7d23b6a2.png";